import { useState } from "react";
import { ReactSVG } from "react-svg";
import { useTranslation } from "react-i18next";

import PaginationComp from "@/components/PaginationComp";

import Star from "@/components/Star";
import Placeholder from "@/pages/Search/PlaceHolderSearch";
import TransLink from "@/utils/TransLink";
import Directions from "./Directions";
import { colors } from "@/theme/theme";

import { ScrollShadow } from "@heroui/scroll-shadow";

import locationlist from "@/assets/locationlist.svg";
import phone from "@/assets/phone.svg";
import calendar from "@/assets/calendar.svg"
import SearchBar from "./SearchBar";

const CATEGORY_COLORS = {
    Activity: "#890077",
    Place: "#00668A",
    Event: "#006E0F",
    Accomodation: "#704700",
    Business: "#5600AD",
};

const SearchItems = ({
    resultsData,
    meta,
    loading,
    setLoading,
    isMapView,
    setHoveredItem,
}) => {

    const { t } = useTranslation(["glossary"])

    return (

        <div className="w-2/4 hidden xl:flex flex-col gap-2 justify-between px-5 pb-5 ">
            <SearchBar />
            <div className="h-[90%] overflow-y-auto">
                {resultsData.length === 0 ? (
                    <div className="text-center text-gray-500 mt-10">
                        {t("no_results", { ns: "glossary" })}
                    </div>
                ) : loading === true ? (
                    <div>
                        {[...Array(5)].map((_, index) => (
                            <div className="mb-5" key={index}>
                                <Placeholder />
                            </div>
                        ))}
                    </div>
                ) : (
                    resultsData.map((item, index) => (

                        <div
                            key={index}
                            className="mb-5 border border-[#1D26CA] 2xl:min-h-[175px] rounded-3xl bg-white shadow-sm flex overflow-hidden mx-2"
                            onMouseEnter={(e) => {
                                setHoveredItem(item);
                                e.currentTarget.style.borderColor =
                                    CATEGORY_COLORS[item.model] || "#1D26CA";
                                e.currentTarget.style.color =
                                    CATEGORY_COLORS[item.model] || "#1D26CA";
                            }}
                            onMouseLeave={(e) => {
                                setHoveredItem(null);
                                e.currentTarget.style.borderColor = "#1D26CA";
                                e.currentTarget.style.color = "inherit";
                            }}
                        >
                            <div className="w-1/3 h-50 min-w-[250px] bg-gray-400 overflow-hidden rounded-xl relative">
                                <TransLink
                                    url={`${item.slug?.prefix}/${item.slug?.key}`}
                                >
                                    <img
                                        src={item.image}
                                        className="w-full h-full object-cover rounded-l-2xl"
                                    />
                                </TransLink>
                            </div>

                            <div className="w-full p-4 flex flex-col max-2xl:justify-center 2xl:justify-between rounded-r-lg space-y-4">

                                <TransLink
                                    url={`${item.slug?.prefix}/${item.slug?.key}`}
                                    className="w-full"
                                >
                                    <div title={item.name}>
                                        <h2 className="text-lg font-bold">
                                            <h1>{item.name}</h1>
                                        </h2>

                                        <div className="text-sm font-semibold flex flex-row justify items-center top-1 relative">
                                            <ReactSVG
                                                src={locationlist}

                                                beforeInjection={(svg) => {
                                                    svg.setAttribute(
                                                        "style",
                                                        "width: 20px; height: 20px;",
                                                    );
                                                    svg.querySelectorAll(
                                                        "path",
                                                    ).forEach((path) => {
                                                        path.setAttribute(
                                                            "fill",
                                                            CATEGORY_COLORS[
                                                            item.model
                                                            ] || "currentColor",
                                                        );
                                                    });
                                                }}
                                            />

                                            <span className="ml-2 text-xs">{item.area}</span>
                                        </div>

                                    </div>
                                </TransLink>

                                <p className="text-black line-clamp-2 text-xs mb-2">
                                    {item.description}
                                </p>

                                {item.model === 'Event' &&
                                    <div className="flex items-center gap-2">
                                        <img src={calendar} />
                                        <p className="text-xs">{item?.start_date} - {item?.end_date}</p>
                                    </div>
                                }

                                <div className={`flex justify-between gap-4 4xl:justify-start 4xl:gap-8 items-center  flex-wrap`}>

                                    <div className="flex gap-4">
                                        <Star circle color={colors.primary} item={item} />
                                        <Directions
                                            iconColor={colors.primary}
                                            whiteIcon
                                            onlyIcon
                                            destinationLat={item.latitude}
                                            destinationLng={item.longitude}
                                        />
                                        <a title={t('contact')} href={`tel:${item.mobile}`} className="border-black border-1 p-2 rounded-full">
                                            <ReactSVG
                                                src={phone}

                                                beforeInjection={(svg) => {
                                                    svg.setAttribute(
                                                        "style",
                                                        "width: 20px; height: auto;",
                                                    );
                                                    svg.querySelectorAll(
                                                        "path",
                                                    ).forEach((path) => {
                                                        path.setAttribute(
                                                            "fill",
                                                            colors.primary
                                                        );
                                                    });
                                                }}
                                            />

                                        </a>
                                    </div>

                                    {item.model === "Accomodation" && item.can_reservation && (
                                        <TransLink
                                            title={t('book_now')}
                                            url={`${item.slug?.prefix}/${item.slug?.key}`}
                                            className="flex-grow max-w-[170px] border h-10 bg-primary text-white rounded-full flex items-center justify-center transition active:scale-95"
                                        >
                                            <div className="text-sm mx-4 font-semibold">
                                                {t('book_now')}
                                            </div>

                                        </TransLink>
                                    )}
                                </div>

                            </div>
                        </div>
                    ))
                )}
            </div>

            <div className="flex justify-center">
                <PaginationComp
                    meta={meta}
                    setLoading={setLoading}
                    isMapView={isMapView}
                />
            </div>
        </div>
    );
};

export default SearchItems;
